import React from 'react'

import {
  useCubeReportAccessFiltersContext,
  useCubeReportPageFiltersContext,
} from 'cube'
import { intComma } from 'humanize-plus'

import { Link, Table, TableColumn } from '@driftt/dds'
import { CubeQueryStringAdapter } from '@driftt/dds.reports'

import { useTrackDrillDownClickEvent } from 'components/conversation/hooks/useTrackDrilldownClickEvent'
import useTimePeriod from 'hooks/useTimePeriod'
import { CONVO_DETAIL_REPORT_PATH } from 'layouts/ConversationsDetailReport/ConversationsDetailReport.constants'

import { TableWrapper } from '../TableWrapper'

import { formatConversationsWithUrlDrillDownQuery } from './ConversationStartedFromTable.helpers'
import { StyledLink } from './ConversationStartedFromTable.styles'
import useConversationsStartedFrom, {
  type ConversationStartedFromTableRow,
} from './useConversationsStartedFrom.hook'

export const ConversationStartedFromTable = () => {
  const { tableData, isLoadingTableData } = useConversationsStartedFrom()
  const timePeriod = useTimePeriod()
  const { pageFilters } = useCubeReportPageFiltersContext()
  const { accessFilters } = useCubeReportAccessFiltersContext()
  const { trackViewEvent } = useTrackDrillDownClickEvent(
    'ConversationStartedFromTable'
  )

  const formatDrillDownURL = (conversationCreatedFromUrl: string): string => {
    const cubeQuery = formatConversationsWithUrlDrillDownQuery(
      conversationCreatedFromUrl,
      timePeriod.startDate,
      timePeriod.endDate,
      [...pageFilters, ...accessFilters]
    )

    return `${CONVO_DETAIL_REPORT_PATH}?${CubeQueryStringAdapter.toQueryString(
      cubeQuery
    )}`
  }

  const defaultColumns: TableColumn<ConversationStartedFromTableRow>[] = [
    {
      header: 'Conversation URL',
      value: 'conversationStartedFromUrl',
      cell: ({ conversationStartedFromUrl }) => (
        <StyledLink
          variant={'inline'}
          external={true}
          href={`https://${conversationStartedFromUrl}`}
        >
          {`https://${conversationStartedFromUrl}`}
        </StyledLink>
      ),
      disableSort: true,
    },
    {
      header: 'Chats',
      value: 'conversationCount',
      cell: ({ conversationCount, conversationStartedFromUrl }) => (
        <Link
          target="_blank"
          variant="inline"
          href={formatDrillDownURL(conversationStartedFromUrl)}
          onClick={() =>
            trackViewEvent({ totalRecords: conversationCount ?? 0 })
          }
        >
          {intComma(conversationCount)}
        </Link>
      ),
      disableSort: true,
    },
  ]
  return (
    <TableWrapper
      title={'Top URLs'}
      description={'What are the most common URLs chats start from?'}
      rootProps={{
        id: 'chats-report--conversation-started-from-table',
      }}
    >
      <Table
        height={400}
        rows={tableData}
        columns={defaultColumns}
        isLoading={isLoadingTableData}
        loadingRows={10}
        disableBoxShadow={true}
      />
    </TableWrapper>
  )
}
